(()=>{const CS='.fp-product-card,.fp-search-product,.fp-discovery-card,.fp-rec-card,.fp-recent-card';const PRICE='.fp-product-card__price,.fp-search-product__price,.fp-discovery-card__price,.fp-recent-card__price,.fp-rec-card__pricing>span:first-child';const cache=new Map();let io=null;function css(){if(document.getElementById('fp-card-commerce-style'))return;const s=document.createElement('style');s.id='fp-card-commerce-style';s.textContent='.fp-card-price-prefix{display:inline-block;color:#555;font-size:10px;font-weight:750;line-height:1;margin-right:3px;vertical-align:baseline}.fp-product-card__price,.fp-search-product__price,.fp-discovery-card__price,.fp-recent-card__price,.fp-rec-card__pricing>span:first-child{font-size:17px!important;font-weight:950!important;letter-spacing:-.035em!important}@media(max-width:749px){.fp-product-card__price,.fp-search-product__price,.fp-discovery-card__price,.fp-recent-card__price,.fp-rec-card__pricing>span:first-child{font-size:16px!important}.fp-card-price-prefix{font-size:9px}}';document.head.appendChild(s)}function handle(card){const w=card.querySelector('[data-fp-wishlist-button][data-product-handle]');if(w&&w.dataset.productHandle)return w.dataset.productHandle;const a=card.querySelector('a[href*="/products/"]');if(!a)return'';try{const m=new URL(a.href,location.origin).pathname.match(/\/products\/([^/?#]+)/);return m?decodeURIComponent(m[1]):''}catch(e){return''}}function load(h){if(cache.has(h))return cache.get(h);const root=window.Shopify&&window.Shopify.routes?window.Shopify.routes.root:'/';const p=fetch(root+'products/'+encodeURIComponent(h)+'.js',{headers:{Accept:'application/json'}}).then(r=>r.ok?r.json():null).catch(()=>null);cache.set(h,p);return p}async function enrich(card){if(!card||card.dataset.fpCardCommerce==='true')return;card.dataset.fpCardCommerce='true';const h=handle(card),price=card.querySelector(PRICE);if(!h||!price)return;const p=await load(h);if(!p||!Array.isArray(p.variants)||!p.variants.length)return;const prices=new Set(p.variants.map(v=>Number(v.price)).filter(Number.isFinite));if(prices.size>1){const parent=price.parentElement;if(parent&&!parent.querySelector('.fp-card-price-prefix')){const prefix=document.createElement('span');prefix.className='fp-card-price-prefix';prefix.textContent='From';price.before(prefix)}}}function observe(root=document){root.querySelectorAll(CS).forEach(card=>{if(card.dataset.fpCardCommerceObserved==='true')return;card.dataset.fpCardCommerceObserved='true';if(io)io.observe(card);else enrich(card)})}function boot(){css();if('IntersectionObserver'in window){io=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){enrich(entry.target);io.unobserve(entry.target)}})},{rootMargin:'240px 0px'})}observe()}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();document.addEventListener('shopify:section:load',e=>{if(e.target&&e.target.querySelectorAll)observe(e.target)})})();

(() => {
  const selector = '.fp-product-card,.fp-search-product,.fp-discovery-card,.fp-rec-card,.fp-recent-card';
  const pricingSelector = '.fp-product-card__pricing,.fp-search-product__pricing,.fp-discovery-card__price-row,.fp-rec-card__pricing,.fp-recent-card__pricing';
  const actionsSelector = '.fp-product-card__actions,.fp-search-product__action,.fp-discovery-card__actions,.fp-rec-card__actions,.fp-recent-card__actions';
  const mobile = matchMedia('(max-width: 749px)');
  const records = new Set();
  const seen = new WeakSet();

  const icon = '<svg class="fp-compact-cart-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M2.5 4.5h3l2.1 10.1a2 2 0 0 0 2 1.6h7.6a2 2 0 0 0 2-1.6l1.2-6.1M14 4v6M11 7h6"/><circle cx="10" cy="20" r="1"/><circle cx="18" cy="20" r="1"/></svg>';

  function position(record) {
    const {price, actions, priceSlot, actionSlot, row} = record;

    if (mobile.matches) {
      priceSlot.after(row);
      row.append(price, actions);
    } else {
      priceSlot.after(price);
      actionSlot.after(actions);
      row.remove();
    }
  }

  function enhance(card) {
    if (seen.has(card)) return;

    const price = card.querySelector(pricingSelector);
    const actions = card.querySelector(actionsSelector);
    const control = actions?.querySelector('button,a');

    if (!price || !actions || !control) return;

    seen.add(card);

    const priceSlot = document.createComment('');
    const actionSlot = document.createComment('');

    price.before(priceSlot);
    actions.before(actionSlot);

    const row = document.createElement('div');
    row.className = 'fp-compact-cart-row';

    price.classList.add('fp-compact-cart-price');
    actions.classList.add('fp-compact-cart-actions');
    control.classList.add('fp-compact-cart-control');
    control.insertAdjacentHTML('beforeend', icon);

    const record = {
      card,
      price,
      actions,
      priceSlot,
      actionSlot,
      row
    };

    records.add(record);
    position(record);
  }

  function scan(root) {
    if (!(root instanceof Element || root instanceof Document)) return;

    if (root.matches?.(selector)) enhance(root);
    root.querySelectorAll(selector).forEach(enhance);
  }

  function boot() {
    const style = document.createElement('style');

    style.textContent = `
      .fp-compact-cart-control > .fp-compact-cart-icon {
        display: none !important;
      }

      @media (max-width: 749px) {
        body #MainContent .fp-compact-cart-row {
          display: flex !important;
          align-items: center !important;
          gap: 6px !important;
          width: 100% !important;
          min-width: 0 !important;
          margin-top: 4px !important;
        }

        body #MainContent .fp-compact-cart-row > .fp-compact-cart-price {
          display: flex !important;
          flex: 1 1 0% !important;
          flex-wrap: wrap !important;
          align-items: baseline !important;
          gap: 2px 4px !important;
          min-width: 0 !important;
          margin: 0 !important;
          padding: 0 !important;
        }

        body #MainContent .fp-compact-cart-row > .fp-compact-cart-actions {
          display: block !important;
          flex: 0 0 44px !important;
          width: 44px !important;
          min-width: 44px !important;
          margin: 0 !important;
          padding: 0 !important;
        }

        body #MainContent .fp-compact-cart-actions > .fp-compact-cart-control {
          position: relative !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 44px !important;
          min-width: 44px !important;
          max-width: 44px !important;
          height: 44px !important;
          min-height: 44px !important;
          padding: 0 !important;
          margin: 0 !important;
          border: 0 !important;
          border-radius: 0 !important;
          background: transparent !important;
          color: #111 !important;
          box-shadow: none !important;
          font-size: 0 !important;
          gap: 0 !important;
          line-height: 0 !important;
          transform: none !important;
        }

        body #MainContent .fp-compact-cart-control::before {
          content: '' !important;
          position: absolute !important;
          inset: 7px 0 !important;
          border: 1.5px solid currentColor !important;
          border-radius: 999px !important;
          background: #fff !important;
          box-shadow: none !important;
        }

        body #MainContent .fp-compact-cart-control::after {
          display: none !important;
        }

        body #MainContent .fp-compact-cart-control > svg {
          display: none !important;
        }

        body #MainContent .fp-compact-cart-control > span {
          position: absolute !important;
          width: 1px !important;
          height: 1px !important;
          padding: 0 !important;
          overflow: hidden !important;
          clip-path: inset(50%) !important;
          white-space: nowrap !important;
        }

        body #MainContent .fp-compact-cart-control > .fp-compact-cart-icon {
          position: relative !important;
          display: block !important;
          width: 23px !important;
          height: 23px !important;
          margin: 0 !important;
          fill: none !important;
          stroke: currentColor !important;
          stroke-width: 1.9 !important;
          stroke-linecap: round !important;
          stroke-linejoin: round !important;
        }

        body #MainContent .fp-compact-cart-control:disabled {
          opacity: .4 !important;
          cursor: default !important;
        }

        body #MainContent .fp-compact-cart-control:active:not(:disabled)::before {
          background: #f2f2f2 !important;
        }

        body #MainContent .fp-compact-cart-control:focus-visible {
          outline: 2px solid #ff6a00 !important;
          outline-offset: 2px !important;
          border-radius: 999px !important;
        }
      }
    `;

    document.head.append(style);
    scan(document);

    new MutationObserver(mutations => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          scan(node);
        }
      }

      for (const record of records) {
        if (!record.card.isConnected) records.delete(record);
      }
    }).observe(
      document.querySelector('#MainContent') || document.body,
      {
        childList: true,
        subtree: true
      }
    );

    mobile.addEventListener('change', () => records.forEach(position));

    document.addEventListener('shopify:section:load', event => {
      scan(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, {once: true});
  } else {
    boot();
  }
})();